import api from './api'
import { organizationContextStore } from 'shared/stores/organizationContextStore'

function withOrganizationContext(config = {}) {
	return {
		...config,
		headers: {
			...(config.headers || {}),
			...organizationContextStore.contextHeaders,
		},
	}
}

export const fetchAcademicCalendar = () =>
	api.get('/counseling/organization/academic-calendar', withOrganizationContext())

export const putAcademicCalendar = payload =>
	api.put(
		'/counseling/organization/academic-calendar',
		payload,
		withOrganizationContext(),
	)
